<template>
  <div>
    <ModalCardDefault :title="'Duplicar Estado'" @close="$emit('close')">
      <ExpansionPanel
        v-model="panel"
        :title="'Selecione o Estado da Duplicação'"
        :icon="$icons.box"
        readonly
      >
        <Select
          v-model="natureOperationStateUf"
          :items="natureOperationStates"
          item-text="name"
          item-value="uf"
          label="Estado"
          :rules="[required]"
        />
      </ExpansionPanel>

      <div class="d-flex justify-end mt-5">
        <Button
          :label="'Duplicar'"
          color="secondary"
          rounded
          :disabled="!natureOperationStateUf"
          @click="$emit('duplicateState', natureOperationStateUf)"
        />
      </div>
    </ModalCardDefault>
  </div>
</template>

<script>
import ModalCardDefault from '@/components/ModalCardDefault';
import { Select, ExpansionPanel, Button } from '@/components/vuetify';
import { UF } from '@/utils/options';
import { required } from '@/utils/rules';

export default {
  name: 'DuplicateNatureOperationStates',
  components: {
    ModalCardDefault,
    Select,
    ExpansionPanel,
    Button,
  },
  props: {
    loadingDuplicateNatureOperationState: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      panel: [0],
      natureOperationStateUf: '',
      ufs: UF,
      rules: { required: required },
    };
  },
};
</script>
